export enum RostersEnum {
        ExtendedNewbornRoster = 5170,
        OnCallRoster = 49,
        HospitalRoundingRoster = 50,
        VacationRoster = 51,
}
